export { default } from './HeadContent';
